import { render, staticRenderFns } from "./HistoryComment.vue?vue&type=template&id=fa35eea2&"
import script from "./HistoryComment.vue?vue&type=script&lang=js&"
export * from "./HistoryComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports